import { postList } from '../libs/post-list';

export default (page) => ({
  page: page,
  fetching: false,
  init() {
    this.$refs.pagination.addEventListener('click', (event) => {
      event.preventDefault();
      if (event.target.classList.contains('next')) {
        this.page += 1;
      } else if (event.target.classList.contains('prev')) {
        this.page -= 1;
      } else {
        this.page = parseInt(event.target.innerHTML);
      }

      this.filter(false);
    });
  },
  filter(reset) {
    this.fetching = true;

    if (reset) {
      this.page = 1;
    }

    let id = this.$refs.filter.value;

    const data = {
      action: 'blog_insights',
      page: this.page,
      category: id,
      base: window.location.href,
    };
    fetch(ajax_object.ajaxurl + '?action=' + data.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        this.$refs.container.innerHTML = '';
        this.$refs.pagination.innerHTML = json.pagination;

        [...json.posts].forEach((v, i, a) => {
          this.$refs.container.insertAdjacentHTML('beforeend', v);
        });

        postList();

        this.$refs.filter.scrollIntoView({ behavior: 'smooth' });
      });
  },
});
